var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"self"},[_c('div',{ref:"mainHeader",staticClass:"mainHeader"},[_vm._t("mainHeader")],2),_c('div',{staticClass:"page",style:(_vm.getPageStyle)},[_vm._t("page",null,{"layoutParams":_vm.params})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }